'use client';

/**
 * Re-export all hooks from the hooks directory
 * @deprecated - Import directly from hooks/ instead
 */

export * from './hooks';
